<template>
  <router-view />
</template>

<script>
export default {
  name: 'Team'
}
</script>

<style scoped>

</style>
